import React, { useRef } from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import ViewMore from '../../components/ViewMore';

const HealthcareProblems = props => {
  const slider = useRef();

  const settings = {
    infinite: true,
    speed: 300,
    swipe: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrow: false,
    autoplay: true,

    responsive: [
      {
        breakpoint: 767,
        settings: {
          autoplay: false,
          slidesToShow: 1,
          swipe: true,
          arrows: false,
          dots: true,
          dotsClass: 'custom-dots',
          centerMode: true,
          centerPadding: '25px',
        },
      },
    ],
  };

  return (
    <>
      <style>{`
             .slick-track {
                display:flex;
                margin:0
              }
            .slick-slide{
                width:33%;
                margin-right:5px
            }
             .slick-slide {
                    outline: none
                }
                .slick-slide div {
                    outline: none
                }
                .slick-slide:focus,.slick-slide a{
                    outline: none;
                }
                .shadow-new{
                    box-shadow: 0px 1px 3px 1px rgb(0 0 0 / 7%);
                    border-radius: 0px 0px 25px 25px;
                }
                .shadow-new-w{
                    box-shadow: 0px 1px 6px 1px rgb(0 0 0 / 7%);
                }
                .custom-dots{
                      display:flex!important    ;
                      justify-content:center;
                  }
                  .custom-dots li{
                      position:relative;
                      margin:0 3px;
                      margin-top:20px;
                      width:50px;
                      height:2px;
                      background-color: #C4C4C4; 
                      overflow:hidden;
                  }
                  .custom-dots li.slick-active{
                      background-color:#670F7A;
                  }
                  .custom-dots li button{
                      position:absolute;
                      width:100%;
                      height:100%;
                      top:0;
                      left:0;
                      opacity:0;
                      //display:none;
                  }
                    .slick-list:first-of-type,for-hover:first-of-type{
                                padding-left:0!important;
                            }
            `}</style>
      <Slider ref={slider} {...settings} className="relative z-10 pt-24   ">
        <div className={'w-30p block mr-10 pr-0 md:pr-15'}>
          <div className={'bg-gray-slideOne px-18 py-12  min-h-340 md:min-h-280'}>
            <h3 className={'font-bold text-24 leading-29 text-purple'}>Video clarifies</h3>
            <div className={'pr-0 md:pr-30'}>
              <p className={'mt-10'}>
                The gap caused by the complexity of SaaS products can be easily covered with a simple and interactive video. A simple scenario with
                words and visuals will explain how your SaaS product works and make customers more ready and open to hearing your pitch.{' '}
              </p>
            </div>
          </div>
        </div>
        <div className={'w-30p mr-10 px-0 md:px-15'}>
          <div className={'bg-red-slideTwo px-18 py-12  min-h-340 md:min-h-280'}>
            <h3 className={'font-bold text-24 leading-29 text-purple'}>Video specifies</h3>
            <div className={'mt-10'}>
              <div>
                <p className={'mt-10'}>
                  SaaS product is not “toy.” It is highly specific and often complicated for users. Technology videos can reveal the specifics of the
                  product, for example, the installation process or how to navigate.
                </p>
                {/*<ViewMore ln={30}>*/}
                {/*</ViewMore>*/}
              </div>
            </div>
          </div>
        </div>
        <div className={'w-30p mr-10 pl-0 md:pl-15'}>
          <div className="bg-blue-slideTree px-18 py-12  min-h-340 md:min-h-280">
            <h3 className={'font-bold text-24 leading-29 text-purple'}>Video proves</h3>

            <p className={'mt-10'}>
              To prove the value and functionality of your SaaS product, your users can at least see how it works, and SaaS video is the best means to
              offer that experience. Explain your product’s benefits and value proposition, and showcase the usage and best practices.{' '}
            </p>
          </div>
        </div>
      </Slider>
    </>
  );
};
export default HealthcareProblems;
